import { useState, useCallback } from 'react'

export type Pagination = {
	current: number
	pageSize: number
	total: number
}

type ResData = {
	current?: number | string
	size?: number | string
	total?: number | string
	page?: number | string
	pageSize?: number | string
}

export const usePagination = (initialCurrent = 1, initialPageSize = 20) => {
	const [pagination, setPagination] = useState<Pagination>({
		current: initialCurrent,
		pageSize: initialPageSize,
		total: 0
	})

	const updateFromRes = useCallback((resData: ResData) => {
		setPagination((p) => ({
			current: Number(resData.current),
			pageSize: Number(resData.size),
			total: Number(resData.total)
		}))
	}, [])

	const setCurrent = useCallback((current: number) => {
		setPagination((p) => ({ ...p, current }))
	}, [])

	const setPageSize = useCallback((pageSize: number) => {
		setPagination((p) => ({ ...p, pageSize }))
	}, [])

	return {
		...pagination,
		updateFromRes,
		setCurrent,
		setPageSize
	}
}
